import { Component } from "react";

export default class Tasks extends Component{
    
}